document.addEventListener('DOMContentLoaded', function() {
  if (!window.location.pathname.includes('/cart')) return;

  // Settings
  const freeGiftProductHandle = 'free-gift';
  const minimumCartAmount = 6000; // $60 in cents
  const popup = document.getElementById('free-gift-popup');
  const closeBtn = document.getElementById('close-popup');
  const body = document.body;

  // Request lock & debounce
  let isChecking = false;
  let debounceTimer;

  function debounceCheck() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(checkFreeGift, 1000); // Wait 1s after last event
  }

  // Close popup
  closeBtn?.addEventListener('click', function() {
    popup.style.display = 'none';
    body.classList.remove('popup-open');
    window.location.reload();
  });

  // Main logic
  async function checkFreeGift() {
    if (isChecking) return;
    isChecking = true;

    try {
      const [cartRes, productRes] = await Promise.all([
        fetch('/cart.js'),
        fetch(`/products/${freeGiftProductHandle}.js`)
      ]);

      const [cart, product] = await Promise.all([
        cartRes.json(),
        productRes.json()
      ]);

      const giftItem = cart.items.find(item => item.product_id === product.id);
      const qualifiesForGift = cart.total_price >= minimumCartAmount;

      // Case 1: Add gift if qualified
      if (qualifiesForGift && !giftItem) {
        const variantId = product.variants?.[0]?.id;
        console.log("variantId...", variantId)
        if (!variantId) throw new Error("Free gift has no variants");

        await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1, properties: { '_free_gift': 'true' } }]
          })
        });

        // Show popup
        popup.style.display = 'flex';
        body.classList.add('popup-open');
      }
      // Case 2: Remove gift if no longer qualified
      else if (!qualifiesForGift && giftItem) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: giftItem.key, quantity: 0 })
        });
        window.location.reload();
      }
    } catch (error) {
      console.error('Free Gift Error:', error);
    } finally {
      isChecking = false;
    }
  }

  // Initialize
  debounceCheck();

  // Event listeners (debounced)
  document.querySelector('.cart')?.addEventListener('change', function(e) {
    if (e.target.matches('.cart__quantity, .cart-item__quantity, [name="updates[]"]')) {
      debounceCheck();
    }
  });

  document.querySelector('.cart')?.addEventListener('click', function(e) {
    if (e.target.closest('.cart__remove, .cart-item__remove')) {
      debounceCheck();
    }
  });
});